'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_OPTIONS = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _constants = require('../constants');

var _nonCanonical = require('./nonCanonical');

var _getDeviceType = require('./getDeviceType');

var _getDeviceType2 = _interopRequireDefault(_getDeviceType);

var _getBettingAccountLoggedInStatus = require('./cookie/getBettingAccountLoggedInStatus');

var _getBettingAccountLoggedInStatus2 = _interopRequireDefault(_getBettingAccountLoggedInStatus);

var _getUserName = require('./cookie/getUserName');

var _getUserName2 = _interopRequireDefault(_getUserName);

var _getUserId = require('./cookie/getUserId');

var _getUserId2 = _interopRequireDefault(_getUserId);

var _commonTraits = require('./commonTraits');

var _getUTMParams = require('./utm/getUTMParams');

var _getUTMParams2 = _interopRequireDefault(_getUTMParams);

var _traits = require('../traits');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_OPTIONS = exports.DEFAULT_OPTIONS = {
    integrations: {
        All: true
    }
};

function dispatchGlobalPageViewEvent() {
    /* window_.dispatchEvent(new Event('RP_PAGE_VIEW')); IE does not work with this */
    var event = global.document.createEvent('Event');
    event.initEvent('RP_PAGE_VIEW', false, true);
    global.dispatchEvent(event);
}

function page(name) {
    var _extends2;

    var traits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_OPTIONS;

    // Overwrite segment defaults to use a non canonical values
    var properties = {
        path: (0, _nonCanonical.getNonCanonicalPath)(),
        url: (0, _nonCanonical.getNonCanonicalUrl)()
    };

    var userName = (0, _getUserName2.default)();
    if (userName) {
        properties[_traits.TRAIT_USER_NAME] = userName;
    }

    var userId = (0, _getUserId2.default)();
    if (userId) {
        properties[_traits.TRAIT_USER_ID] = userId;
    }

    var commonTraits = (0, _commonTraits.getCommonTraits)();
    if (commonTraits && commonTraits[_traits.TRAIT_SITE_SECTION]) {
        properties[_traits.TRAIT_SITE_SECTION] = commonTraits[_traits.TRAIT_SITE_SECTION];
        properties[_traits.TRAIT_SITE_SUB_SECTION_1] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_1];
        properties[_traits.TRAIT_SITE_SUB_SECTION_2] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_2];
    }

    var bettingAccountLoggedIn = (0, _getBettingAccountLoggedInStatus2.default)();

    properties = (0, _extends4.default)((_extends2 = {}, (0, _defineProperty3.default)(_extends2, _traits.TRAIT_DEVICE_TYPE, (0, _getDeviceType2.default)()), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_LOGGED_IN_STATUS, userId ? 'Logged In' : 'Logged Out'), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS, bettingAccountLoggedIn ? 'Logged In' : 'Logged Out'), _extends2), properties, (0, _getUTMParams2.default)(), traits);

    return new Promise(function (resolve) {
        // Segment Page event
        if (!global.analytics) {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
            resolve();
            return;
        }

        global.analytics.page(name, properties, options, resolve);
    }).then(dispatchGlobalPageViewEvent);
}

page.DEFAULT_OPTIONS = DEFAULT_OPTIONS;

exports.default = page;


//////////////////
// WEBPACK FOOTER
// ./~/rp-analytics/lib/utils/page.js
// module id = 1364
// module chunks = 1